var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableDate',{attrs:{"allData":_vm.tableData,"name":_vm.name,"code":_vm.code,"toDetail":_vm.toDetail}})
}
var staticRenderFns = []

export { render, staticRenderFns }